export default __webpack_public_path__ + "static/media/mad-ape-006.0e25473a.svg";